import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VATRatesComponent } from './manage-vatrate.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  { path: '', component: VATRatesComponent, data: { title: 'Manage VAT Rates' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageVatrateRoutingModule {}

@NgModule({
  imports: [
    ManageVatrateRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [VATRatesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageVatrateModule {}
